import React from 'react';
import { Icon } from '@ui-kitten/components';

import Button from '../../../../Components/Button';
import themeStyle from '../../../../Theme/styles';

const EditButton = (props) => (
  <Button
    accessoryLeft={(props) => (
      <Icon
        {...props}
        name="edit-2"
        style={[props.style, { marginHorizontal: 0 }]}
      />
    )}
    size="small"
    status="info"
    style={[{ borderRadius: 5 }, themeStyle.spacingLeftMedium]}
    {...props}
  >
    Edit
  </Button>
);

export default EditButton;
